import { create } from "zustand";

type StoreProps<IntlShape> = {
  intl: IntlShape | undefined;
  setIntl: (intl: IntlShape) => void;
};

export const createIntlConfigurationStore = <IntlShape>() =>
  create<StoreProps<IntlShape>>(set => ({
    intl: undefined,
    setIntl: intl => set({ intl }),
  }));
